/* hotkeys that execute actions in qwt */

export enum HotKeys {
    OpenGenerator = 75,
    ExecuteQuery = 83
}
